// Responsive
GLOBAL.windowSize = {};

GLOBAL.responsive = () => {
  // May include scrollbars sizes
  GLOBAL.windowSize.width = document.documentElement.clientWidth;
  GLOBAL.windowSize.height = document.documentElement.clientHeight;

  // Set CSS variable to correct window height calculation for mobile browsers
  const vh = GLOBAL.windowSize.height * .01;

  document.documentElement.style.setProperty('--vh', `${vh}px`);

  // If changed only window height
  GLOBAL.onlyWindowHeightChanged = false;
  if (GLOBAL.windowSize.previousWidth == GLOBAL.windowSize.width) {
    GLOBAL.onlyWindowHeightChanged = true;
  }
  GLOBAL.windowSize.previousWidth = GLOBAL.windowSize.width;
}


window.addEventListener('DOMContentLoaded', () => {

  // Useful classes for responsive design
  const html = document.querySelector('html');

  html.classList.remove('no-js');
  html.classList.add(GLOBAL.isTouchscreen ? 'isTouchscreen' : 'isDesktop');

  // Make responsive
  GLOBAL.responsive();

}, false);


window.addEventListener('resize', () => {

  // Make responsive
  GLOBAL.responsive();

}, false);


window.addEventListener('load', () => {

  // Make responsive
  GLOBAL.responsive();


  // Index page
  if (document.body.classList.contains('index-page')) {

    // Start animations
    document.body.classList.remove('paused');

  }

}, false);